import Controller from "@ember/controller";
import { computed } from "@ember/object";
import { service } from "@ember/service";
import { i18n } from "discourse-i18n";

export default class UserCirclesIndexController extends Controller {
  @service currentUser;

  #availableTypes = ["member", "staff"];

  @computed("#availableTypes", "currentUser", "model.username")
  get types() {
    const isSelf = this.currentUser?.username === this.model.username;

    return this.#availableTypes.map((type) => {
      const name = isSelf ? type : type + "-else";

      return {
        id: type,
        name,
        title: i18n(`discourse_circles.index.user.types.${name}.title`),
        route: `user.circles.type`,
        model: type,
      };
    });
  }
}
